import {Constants} from './actions'


const initialState = {
  requesting: false,
  successful: false,
  data: {
    donHangThang: 0,
    doanhSoThang: 0,
    khachGiaoDichThang: 0,
    tongKhach: 0,
    doPhuNganhThang: 0,
    tongPhuNganh: 0,
  }
}


const reducer = function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA:
      return {
        ...state,
        requesting: true,
        successful: false,
      }
    case Constants.SET_DATA:
      return {
        ...state,
        successful: true,
        data: action.payload
      }
    case Constants.SET_LOADING:
      return {
        ...state,
        requesting: action.payload,
      }
    default:
      return state
  }
}

export default reducer


// WEBPACK FOOTER //
// ./src/components/Stats/reducer.js